import React from 'react';
interface HeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}
export function Header({
  title,
  subtitle,
  children
}: HeaderProps) {
  return <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-8 py-5 transition-colors" data-id="element-272">
      <div className="flex items-center justify-between" data-id="element-273">
        <div data-id="element-274">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-275">
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-276">
              {subtitle}
            </p>}
        </div>
        {children && <div className="flex items-center gap-3" data-id="element-277">{children}</div>}
      </div>
    </header>;
}